
declare global {
  interface Window {
    _env_?: any;
  }
}
const env = window._env_ || {};


const BASE_URL = env.HOST_URL;
export const PRIVACY_POLICY_URL = env.PRIVACY_POLICY_URL;
export const NOTIFICATION_URL = env.NOTIFICATION_URL;
export const EULA_URL = env.EULA_URL;
export const COOKIE_POLICY_URL = env.COOKIE_POLICY_URL;
export const MODERN_ANTI_SLAVERY_POLICY_URL = env.MODERN_ANTI_SLAVERY_POLICY_URL;
export const TERMS_OF_SERVICE_URL = env.TERMS_OF_SERVICE_URL;
export const CONCEPT_EXPLORER_TOOLTIP_URL = env.CONCEPT_EXPLORER_TOOLTIP_URL;
export const COMMUNICATION_EXPLORER_TOOLTIP_URL = env.COMMUNICATION_EXPLORER_TOOLTIP_URL;
export const CATEGORISATION_TOOLTIP_URL = env.CATEGORISATION_TOOLTIP_URL;
export const APP_VERSION = env.APP_VERSION;
export const NOTIFICATIONS_API_KEY = env.NOTIFICATIONS_API_KEY;
export const USER_SESSION_TIMEOUT_IN_MINUTES=env.USER_SESSION_TIMEOUT_IN_MINUTES;
export const USER_SESSION_IDLE_GRACE_TIMEOUT_IN_MINUTES=env.USER_SESSION_IDLE_GRACE_TIMEOUT_IN_MINUTES;
export const AVR_GTM_ID = env.AVR_GTM_ID;
export const AVR_ENABLE_GTM = env.AVR_ENABLE_GTM;
export const GTM_BASE_URL = env.GTM_BASE_URL;
// For boolean flags, convert string "true" or boolean true to actual boolean
export const SSO_ENABLED = env.SSO_ENABLED === false || env.SSO_ENABLED;

const userTimeoutInMinutes =
  Number(USER_SESSION_TIMEOUT_IN_MINUTES) || 30;

const userIdleGraceTimeoutInMinutes =
  Number(
    USER_SESSION_IDLE_GRACE_TIMEOUT_IN_MINUTES
  ) || 3;

export const timeoutConfig = {
  USER_IDLE_TIMEOUT_SEC: userTimeoutInMinutes * 60 * 1000, //[30m] -- unit in milliseconds
  USER_IDLE_GRACEPERIOD_SEC: userIdleGraceTimeoutInMinutes * 60, // [3m] -- unit in seconds
};

export default BASE_URL;






